import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    initMetaPixel,
    trackMetaEvent,
    trackMetaPageView,
} from "../utils/metaPixel";

export default function MetaPixelTracker() {
    const location = useLocation();

    useEffect(() => {
        initMetaPixel();
    }, []);

    useEffect(() => {
        const pagePath = `${location.pathname}${location.search}`;
        const pageTitle =
            typeof document !== "undefined" ? document.title || "Beach Bum Pass" : "Beach Bum Pass";

        trackMetaPageView(
            {
                page_path: pagePath,
                page_title: pageTitle,
            },
            pagePath
        );

        if (location.pathname === "/passes") {
            trackMetaEvent("ViewContent", {
                content_name: "Beach Bum Pass",
                content_category: "Pass",
                content_type: "product",
                currency: "USD",
            });
        }
    }, [location.pathname, location.search]);

    return null;
}
